import type { InvoiceOverview } from '@vy/api-definition';
import React from 'react';
import type { VyTableMinimalProps } from '../../../../../../components/new-design/table/vy-table/vy-table-types';
import { VyTable } from '../../../../../../components/new-design/table/vy-table/VyTable';
import { useIsIssueOnEndOfMonthActive } from '../../../../../../hooks/use-is-issue-on-end-of-month-active';
import { getSyncInvoicesColumns } from '../sync-invoices-dialog-consts/sync-invoices-columns';

type SyncInvoicesTableProps = Omit<VyTableMinimalProps<InvoiceOverview>, 'tableName'>;

export const SyncInvoicesTable: React.FC<SyncInvoicesTableProps> = ({ items, itemsCount }) => {
  const issueOnEndOfMonth = useIsIssueOnEndOfMonthActive();
  const columns = getSyncInvoicesColumns({ issueOnEndOfMonth });

  return (
    <div className="flex h-full w-full flex-col">
      <VyTable
        tableName="sync-invoices"
        itemsCount={itemsCount}
        items={items}
        columns={columns}
        showPagination={false}
        sx={{
          marginBottom: '30px',
        }}
      />
    </div>
  );
};
